"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../common");
const common_content_schema_1 = require("./common-content-schema");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'v2/user-profile/classes';
exports.method = common_1.HttpMethod.POST;
// #region Request
// Тело запроса. Optional
exports.BodySchema = zod_1.z.object({
  author_id: zod_1.z.string().uuid().optional().nullable(),
  subject_id: zod_1.z.array(zod_1.z.coerce.number()).or(zod_1.z.coerce.number()).transform(value => Array.isArray(value) ? value : [value]).optional(),
  category_id: zod_1.z.coerce.number().optional(),
  exclude_id: zod_1.z.string().optional(),
  page: zod_1.z.coerce.number().min(1),
  pageSize: zod_1.z.coerce.number().min(1)
});
function parseBody(values) {
  return exports.BodySchema.parse(values);
}
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.ResponseSchema = zod_1.z.object({
  data: zod_1.z.array(common_1.userServiceSchema),
  pagination: common_content_schema_1.paginationSchema
});
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
